import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './ValidationError.module.css';

/**
 * This component can be used to show validation errors next to form
 * input fields. The component takes the final-form Field component
 * `meta` object as a prop and infers if an error message should be
 * shown.
 */
const ValidationError = props => {
  const { rootClassName, className, fieldMeta, id } = props;
  const { touched, error } = fieldMeta;
  const classes = classNames(rootClassName || css.root, className);
  // `id`: what the field's aria-describedby points at, so screen readers read the message
  return touched && error ? (
    <div id={id || undefined} className={classes}>
      {error}
    </div>
  ) : null;
};

ValidationError.defaultProps = { rootClassName: null, className: null, id: null };

const { shape, bool, string } = PropTypes;

ValidationError.propTypes = {
  id: string,
  rootClassName: string,
  className: string,
  fieldMeta: shape({
    touched: bool.isRequired,
    error: string,
  }).isRequired,
};

export default ValidationError;
